export const initialState = {
  title: 'Logout',
  nmUniqueId: 'no_user',
  isLunaLiteEnabled: false
}

export default (state = initialState) => state
